module.exports = __webpack_public_path__ + "img/Bold 2px-person-white.6cac6c2b.svg";